import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import { Divider, List, ListItem, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import PaypalDonateButton from "./PaypalDonateButton";

function MobileMenu({ darkMode }) {
  const linkClass = "navLink " + (darkMode ? "dark" : "");
  const [drawerOpen, setdrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setdrawerOpen(!drawerOpen);
  };

  return (

      <>
      <AppBar>
              <Toolbar>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1 }}
                ></Typography>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={toggleDrawer}
                  sx={{ mr: 2 }}
                >
                  <MenuIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
        <Drawer
        className="mobileMenu"
          ModalProps={{
            keepMounted: true,
          }}
          anchor="top"
          open={drawerOpen}
          onClose={() => {
            setdrawerOpen(false);
          }}
        >
          <Box
            sx={{ width: "auto" }}
            role="presentation"
            onClick={toggleDrawer}
            onKeyDown={toggleDrawer}
          >
            <List>
              <ListItem>
                <Link className={linkClass} to="/">
                  Random Pose
                </Link>
              </ListItem>
              <Divider />
              <ListItem>
                <Link className={linkClass} to="/threesixty">
                  360 Viewer (beta)
                </Link>
              </ListItem>
              <Divider />
              <ListItem>
                <Link className={linkClass} to="/about">
                  About
                </Link>
              </ListItem>
              <Divider />
              <ListItem>
                <Link className={linkClass} to="/contact">
                  Contact
                </Link>
              </ListItem>
              <Divider />
              <ListItem>
                <PaypalDonateButton />
              </ListItem>
            </List>
          </Box>
          <Box
            sx={{
              textAlign: "right",
              position: "relative",
              bottom: -3,
              backgroundColor: "red",
              visibility: "visible",
              right: 0,
              left: 0,
            }}
          >
            
          </Box>
        </Drawer>

</>
  );
}

export default MobileMenu;
